import { render, staticRenderFns } from "./FileShareModal.vue?vue&type=template&id=c63b8082"
import script from "./FileShareModal.vue?vue&type=script&lang=js"
export * from "./FileShareModal.vue?vue&type=script&lang=js"
import style0 from "./FileShareModal.vue?vue&type=style&index=0&id=c63b8082&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c63b8082')) {
      api.createRecord('c63b8082', component.options)
    } else {
      api.reload('c63b8082', component.options)
    }
    module.hot.accept("./FileShareModal.vue?vue&type=template&id=c63b8082", function () {
      api.rerender('c63b8082', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/File/Modal/FileShareModal.vue"
export default component.exports